import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import Navigation from "src/Components/Navigation";
import { setAlert } from "src/reducers/alertSlice";
import Loading from "src/Components/Loading";

//Services
import { updateClient } from "src/Api/services/clientService";
import { updateUser } from "src/reducers/sessionSlice";
import { getCountries } from "src/Api/services/countries.Service";

const Content = () => {

  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);

  const [stateLoading, setLoading] = useState(false);
  const [stateCountries, setCountries] = useState([]);
  const [stateTimeZones, setTimeZones] = useState([]);

  const [countrySelected, setCountrySelected] = useState(undefined);

  const fetchData = async () => {
    await getCountries()
      .then((resp) => {
        setCountries(resp.data);
        if (session.user?.country) {
          const countryFilter = resp.data.findIndex(country => country.name.common === session.user?.country)
          setCountrySelected(countryFilter);
          setTimeZones(resp.data[countryFilter].timezones);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error", err);
      })
  }

  useEffect(() => {
    fetchData();
  }, []);

  const initForm = {
    id: session.user?.id,
    fullName: session.user?.fullName,
    email: session.user?.email,
    country: session.user?.country,
    city: session.user?.city,
    timezone: session.user?.timezone,
  };
  const [stateForm, setForm] = useState(initForm);

  const reactForm = useFormik({
    initialValues: stateForm,
    validationSchema: Yup.object({
      id: Yup.string().required("Campo requerido"),
      country: Yup.string().required("Campo requerido"),
      city: Yup.string().required("Campo requerido"),
      timezone: Yup.string().required("Campo requerido"),
    }),
    onSubmit: async (values, actions) => {
      setLoading(true);
      let data = { ...values };
      await updateClient(session.user?.id, data)
        .then((resp) => {
          setLoading(false);
          dispatch(updateUser({
            user: resp.data
          }));
          dispatch(
            setAlert({
              msg: "El registro se agrego con éxito",
              type: "success",
            })
          );
        })
        .catch((err) => {
          setLoading(false);
          dispatch(
            setAlert({
              msg: 'Ocurrio un error al procesar la solicitud.',
              type: "error"
            })
          );
        });
    },
  });

  const countryChange = (event) => {
    const country = stateCountries[event.target.value];

    const countryFilterIndex = stateCountries.findIndex(countryFilter => countryFilter.name.common === country.name.common)
    setCountrySelected(countryFilterIndex);

    if (country?.timezones) {
      reactForm.setFieldValue("country", country.name.common);
      reactForm.setFieldValue("timezone", undefined);
      setTimeZones(country.timezones);
    }
    else {
      reactForm.setFieldValue("country", undefined);
      reactForm.setFieldValue("timezone", undefined);
      setTimeZones([]);
    }
  }

  return (
    <div className="grid px-5 py-5">
      <div className="w-full">
        <div className="flex flex-row items-center justify-between mb-4">
          <div className="flex items-center justify-start">
            <div className="text-3xl font-bold">Mi Perfil</div>
          </div>
          <div className="flex items-center">
            {!stateLoading ? (
              <button
                type="submit"
                onClick={reactForm.handleSubmit}
                className="bg-blue hover:bg-hover text-lg text-white py-2 px-4 rounded-lg button-bold"
              >
                Guardar
              </button>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>

      <div className="w-full">
        <div className="text-2xl font-medium text-center text-gray-500 dark:text-gray-800 -ml-3.5">
          <ul className="flex flex-wrap mb-5 ">
            <li className="mr-2">
              <Link
                className="inline-block p-4 rounded-t-lg text-bold  border-b-2 border-transparent hover:text-gray-600 dark:hover:text-gray-500"
                to="/profile"
              >
                Información Personal
              </Link>
            </li>
            <li className="mr-2">
              <Link
                className="inline-block p-4 rounded-t-lg text-blue text-bold border-b-2 border-blue hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-400 active"
                to="/settings"
              >
                Configuración
              </Link>
            </li>
          </ul>
        </div>
      </div>


      <div className="w-full  mb-8">
        <div className="text-lg font-bold mb-8">
          Modifica tus datos cuando sea necesario.
        </div>



        <div className="grid grid-cols-12 gap-6">

          <div className="col-span-12 md:col-span-3">
            <div className="mb-4">
              <label className="block mb-1 text-xl text-gray-900 dark:text-gray-900">
                País de residencia<spam className="text-red-500">*</spam>
              </label>
              <select
                {...reactForm.getFieldProps("country")}
                className={`${reactForm.errors.country
                  ? "bg-red-50 border-red-500"
                  : "bg-white border-gray-300"
                  } border text-gray-900 text-xl rounded-lg p-3 w-full block focus:ring-blue-500 focus:border-blue-500`}
              >
                <option value="AF">Afganistán</option>
                <option value="AL">Albania</option>
                <option value="DE">Alemania</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antártida</option>
                <option value="AG">Antigua y Barbuda</option>
                <option value="AN">Antillas Holandesas</option>
                <option value="SA">Arabia Saudí</option>
                <option value="DZ">Argelia</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaiyán</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrein</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BE">Bélgica</option>
                <option value="BZ">Belice</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermudas</option>
                <option value="BY">Bielorrusia</option>
                <option value="MM">Birmania</option>
                <option value="BO">Bolivia</option>
                <option value="BA">Bosnia y Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BR">Brasil</option>
                <option value="BN">Brunei</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="BT">Bután</option>
                <option value="CV">Cabo Verde</option>
                <option value="KH">Camboya</option>
                <option value="CM">Camerún</option>
                <option value="CA">Canadá</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CY">Chipre</option>
                <option value="VA">Ciudad del Vaticano (Santa Sede)</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comores</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, República Democrática del</option>
                <option value="KR">Corea</option>
                <option value="KP">Corea del Norte</option>
                <option value="CI">Costa de Marfíl</option>
                <option value="CR">Costa Rica</option>
                <option value="HR">Croacia (Hrvatska)</option>
                <option value="CU">Cuba</option>
                <option value="DK">Dinamarca</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egipto</option>
                <option value="SV">El Salvador</option>
                <option value="AE">Emiratos Árabes Unidos</option>
                <option value="ER">Eritrea</option>
                <option value="SI">Eslovenia</option>
                <option value="ES">España</option>
                <option value="US">Estados Unidos</option>
                <option value="EE">Estonia</option>
                <option value="ET">Etiopía</option>
                <option value="FJ">Fiji</option>
                <option value="PH">Filipinas</option>
                <option value="FI">Finlandia</option>
                <option value="FR">Francia</option>
                <option value="GA">Gabón</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GD">Granada</option>
                <option value="GR">Grecia</option>
                <option value="GL">Groenlandia</option>
                <option value="GP">Guadalupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GY">Guayana</option>
                <option value="GF">Guayana Francesa</option>
                <option value="GN">Guinea</option>
                <option value="GQ">Guinea Ecuatorial</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="HT">Haití</option>
                <option value="HN">Honduras</option>
                <option value="HU">Hungría</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IQ">Irak</option>
                <option value="IR">Irán</option>
                <option value="IE">Irlanda</option>
                <option value="BV">Isla Bouvet</option>
                <option value="CX">Isla de Christmas</option>
                <option value="IS">Islandia</option>
                <option value="KY">Islas Caimán</option>
                <option value="CK">Islas Cook</option>
                <option value="CC">Islas de Cocos o Keeling</option>
                <option value="FO">Islas Faroe</option>
                <option value="HM">Islas Heard y McDonald</option>
                <option value="FK">Islas Malvinas</option>
                <option value="MP">Islas Marianas del Norte</option>
                <option value="MH">Islas Marshall</option>
                <option value="UM">Islas menores de Estados Unidos</option>
                <option value="PW">Islas Palau</option>
                <option value="SB">Islas Salomón</option>
                <option value="SJ">Islas Svalbard y Jan Mayen</option>
                <option value="TK">Islas Tokelau</option>
                <option value="TC">Islas Turks y Caicos</option>
                <option value="VI">Islas Vírgenes (EEUU)</option>
                <option value="VG">Islas Vírgenes (Reino Unido)</option>
                <option value="WF">Islas Wallis y Futuna</option>
                <option value="IL">Israel</option>
                <option value="IT">Italia</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japón</option>
                <option value="JO">Jordania</option>
                <option value="KZ">Kazajistán</option>
                <option value="KE">Kenia</option>
                <option value="KG">Kirguizistán</option>
                <option value="KI">Kiribati</option>
                <option value="KW">Kuwait</option>
                <option value="LA">Laos</option>
                <option value="LS">Lesotho</option>
                <option value="LV">Letonia</option>
                <option value="LB">Líbano</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libia</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lituania</option>
                <option value="LU">Luxemburgo</option>
                <option value="MK">Macedonia, Ex-República Yugoslava de</option>
                <option value="MG">Madagascar</option>
                <option value="MY">Malasia</option>
                <option value="MW">Malawi</option>
                <option value="MV">Maldivas</option>
                <option value="ML">Malí</option>
                <option value="MT">Malta</option>
                <option value="MA">Marruecos</option>
                <option value="MQ">Martinica</option>
                <option value="MU">Mauricio</option>
                <option value="MR">Mauritania</option>
                <option value="YT">Mayotte</option>
                <option value="MX" selected>México</option>
                <option value="FM">Micronesia</option>
                <option value="MD">Moldavia</option>
                <option value="MC">Mónaco</option>
                <option value="MN">Mongolia</option>
                <option value="MS">Montserrat</option>
                <option value="MZ">Mozambique</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Níger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk</option>
                <option value="NO">Noruega</option>
                <option value="NC">Nueva Caledonia</option>
                <option value="NZ">Nueva Zelanda</option>
                <option value="OM">Omán</option>
                <option value="NL">Países Bajos</option>
                <option value="PA">Panamá</option>
                <option value="PG">Papúa Nueva Guinea</option>
                <option value="PK">Paquistán</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Perú</option>
                <option value="PN">Pitcairn</option>
                <option value="PF">Polinesia Francesa</option>
                <option value="PL">Polonia</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="UK">Reino Unido</option>
                <option value="CF">República Centroafricana</option>
                <option value="CZ">República Checa</option>
                <option value="ZA">República de Sudáfrica</option>
                <option value="DO">República Dominicana</option>
                <option value="SK">República Eslovaca</option>
                <option value="RE">Reunión</option>
                <option value="RW">Ruanda</option>
                <option value="RO">Rumania</option>
                <option value="RU">Rusia</option>
                <option value="EH">Sahara Occidental</option>
                <option value="KN">Saint Kitts y Nevis</option>
                <option value="WS">Samoa</option>
                <option value="AS">Samoa Americana</option>
                <option value="SM">San Marino</option>
                <option value="VC">San Vicente y Granadinas</option>
                <option value="SH">Santa Helena</option>
                <option value="LC">Santa Lucía</option>
                <option value="ST">Santo Tomé y Príncipe</option>
                <option value="SN">Senegal</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leona</option>
                <option value="SG">Singapur</option>
                <option value="SY">Siria</option>
                <option value="SO">Somalia</option>
                <option value="LK">Sri Lanka</option>
                <option value="PM">St Pierre y Miquelon</option>
                <option value="SZ">Suazilandia</option>
                <option value="SD">Sudán</option>
                <option value="SE">Suecia</option>
                <option value="CH">Suiza</option>
                <option value="SR">Surinam</option>
                <option value="TH">Tailandia</option>
                <option value="TW">Taiwán</option>
                <option value="TZ">Tanzania</option>
                <option value="TJ">Tayikistán</option>
                <option value="TF">Territorios franceses del Sur</option>
                <option value="TP">Timor Oriental</option>
                <option value="TG">Togo</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad y Tobago</option>
                <option value="TN">Túnez</option>
                <option value="TM">Turkmenistán</option>
                <option value="TR">Turquía</option>
                <option value="TV">Tuvalu</option>
                <option value="UA">Ucrania</option>
                <option value="UG">Uganda</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistán</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela</option>
                <option value="VN">Vietnam</option>
                <option value="YE">Yemen</option>
                <option value="YU">Yugoslavia</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabue</option>
              </select>
              {/*<option value=""></option>
                {stateCountries.map((countrie, index) =>
                  <option key={index} value={index}>{countrie.translations['spa'].common}</option>
                )}*/}
              {reactForm.errors.country ? (
                <p className="mt-2 text-base text-red-600 dark:text-red-500">
                  {reactForm.errors.country}
                </p>
              ) : null}
            </div>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="mb-4">
              <label className="block mb-1 text-xl text-gray-900 dark:text-gray-900">
                Ciudad<spam className="text-red-500">*</spam>
              </label>
              <input
                type="text"
                {...reactForm.getFieldProps("city")}
                className={`${reactForm.errors.city
                  ? "bg-red-50 border-red-500"
                  : "bg-white border-gray-300"
                  } border text-gray-900 text-xl rounded-lg p-3 w-full block focus:ring-blue-500 focus:border-blue-500`}
              />
              {reactForm.errors.city ? (
                <p className="mt-2 text-base text-red-600 dark:text-red-500">
                  {reactForm.errors.city}
                </p>
              ) : null}
            </div>
          </div>

        </div>
      </div>

      <div className="w-full  mb-8">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <div className="mb-4">
              <label className="block mb-1 text-xl text-gray-900 dark:text-gray-900">
                Zona horaria<spam className="text-red-500">*</spam>
              </label>
              <select
                {...reactForm.getFieldProps("timezone")}
                className={`${reactForm.errors.timezone
                  ? "bg-red-50 border-red-500"
                  : "bg-white border-gray-300"
                  } border text-gray-900 text-xl rounded-lg p-3 w-full block focus:ring-blue-500 focus:border-blue-500`}
              >

                <option></option>
                <option value="Etc/GMT+12">(GMT-12:00) International Date Line West</option>
                <option value="Pacific/Midway">(GMT-11:00) Midway Island, Samoa</option>
                <option value="Pacific/Honolulu">(GMT-10:00) Hawaii</option>
                <option value="US/Alaska">(GMT-09:00) Alaska</option>
                <option value="America/Los_Angeles">(GMT-08:00) Pacific Time (US & Canada)</option>
                <option value="America/Tijuana">(GMT-08:00) Tijuana, Baja California</option>
                <option value="US/Arizona">(GMT-07:00) Arizona</option>
                <option value="America/Chihuahua">(GMT-07:00) Chihuahua, La Paz, Mazatlan</option>
                <option value="US/Mountain">(GMT-07:00) Mountain Time (US & Canada)</option>
                <option value="America/Managua">(GMT-06:00) Central America</option>
                <option value="US/Central">(GMT-06:00) Central Time (US & Canada)</option>
                <option value="America/Mexico_City">(GMT-06:00) Guadalajara, Mexico City, Monterrey</option>
                <option value="Canada/Saskatchewan">(GMT-06:00) Saskatchewan</option>
                <option value="America/Bogota">(GMT-05:00) Bogota, Lima, Quito, Rio Branco</option>
                <option value="US/Eastern">(GMT-05:00) Eastern Time (US & Canada)</option>
                <option value="US/East-Indiana">(GMT-05:00) Indiana (East)</option>
                <option value="Canada/Atlantic">(GMT-04:00) Atlantic Time (Canada)</option>
                <option value="America/Caracas">(GMT-04:00) Caracas, La Paz</option>
                <option value="America/Manaus">(GMT-04:00) Manaus</option>
                <option value="America/Santiago">(GMT-04:00) Santiago</option>
                <option value="Canada/Newfoundland">(GMT-03:30) Newfoundland</option>
                <option value="America/Sao_Paulo">(GMT-03:00) Brasilia</option>
                <option value="America/Argentina/Buenos_Aires">(GMT-03:00) Buenos Aires, Georgetown</option>
                <option value="America/Godthab">(GMT-03:00) Greenland</option>
                <option value="America/Montevideo">(GMT-03:00) Montevideo</option>
                <option value="America/Noronha">(GMT-02:00) Mid-Atlantic</option>
                <option value="Atlantic/Cape_Verde">(GMT-01:00) Cape Verde Is.</option>
                <option value="Atlantic/Azores">(GMT-01:00) Azores</option>
                <option value="Africa/Casablanca">(GMT+00:00) Casablanca, Monrovia, Reykjavik</option>
                <option value="Etc/Greenwich">(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London</option>
                <option value="Europe/Amsterdam">(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna</option>
                <option value="Europe/Belgrade">(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague</option>
                <option value="Europe/Brussels">(GMT+01:00) Brussels, Copenhagen, Madrid, Paris</option>
                <option value="Europe/Sarajevo">(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb</option>
                <option value="Africa/Lagos">(GMT+01:00) West Central Africa</option>
                <option value="Asia/Amman">(GMT+02:00) Amman</option>
                <option value="Europe/Athens">(GMT+02:00) Athens, Bucharest, Istanbul</option>
                <option value="Asia/Beirut">(GMT+02:00) Beirut</option>
                <option value="Africa/Cairo">(GMT+02:00) Cairo</option>
                <option value="Africa/Harare">(GMT+02:00) Harare, Pretoria</option>
                <option value="Europe/Helsinki">(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius</option>
                <option value="Asia/Jerusalem">(GMT+02:00) Jerusalem</option>
                <option value="Europe/Minsk">(GMT+02:00) Minsk</option>
                <option value="Africa/Windhoek">(GMT+02:00) Windhoek</option>
                <option value="Asia/Kuwait">(GMT+03:00) Kuwait, Riyadh, Baghdad</option>
                <option value="Europe/Moscow">(GMT+03:00) Moscow, St. Petersburg, Volgograd</option>
                <option value="Africa/Nairobi">(GMT+03:00) Nairobi</option>
                <option value="Asia/Tbilisi">(GMT+03:00) Tbilisi</option>
                <option value="Asia/Tehran">(GMT+03:30) Tehran</option>
                <option value="Asia/Muscat">(GMT+04:00) Abu Dhabi, Muscat</option>
                <option value="Asia/Baku">(GMT+04:00) Baku</option>
                <option value="Asia/Yerevan">(GMT+04:00) Yerevan</option>
                <option value="Asia/Kabul">(GMT+04:30) Kabul</option>
                <option value="Asia/Yekaterinburg">(GMT+05:00) Yekaterinburg</option>
                <option value="Asia/Karachi">(GMT+05:00) Islamabad, Karachi, Tashkent</option>
                <option value="Asia/Calcutta">(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi</option>
                <option value="Asia/Calcutta">(GMT+05:30) Sri Jayawardenapura</option>
                <option value="Asia/Katmandu">(GMT+05:45) Kathmandu</option>
                <option value="Asia/Almaty">(GMT+06:00) Almaty, Novosibirsk</option>
                <option value="Asia/Dhaka">(GMT+06:00) Astana, Dhaka</option>
                <option value="Asia/Rangoon">(GMT+06:30) Yangon (Rangoon)</option>
                <option value="Asia/Bangkok">(GMT+07:00) Bangkok, Hanoi, Jakarta</option>
                <option value="Asia/Krasnoyarsk">(GMT+07:00) Krasnoyarsk</option>
                <option value="Asia/Hong_Kong">(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi</option>
                <option value="Asia/Kuala_Lumpur">(GMT+08:00) Kuala Lumpur, Singapore</option>
                <option value="Asia/Irkutsk">(GMT+08:00) Irkutsk, Ulaan Bataar</option>
                <option value="Australia/Perth">(GMT+08:00) Perth</option>
                <option value="Asia/Taipei">(GMT+08:00) Taipei</option>
                <option value="Asia/Tokyo">(GMT+09:00) Osaka, Sapporo, Tokyo</option>
                <option value="Asia/Seoul">(GMT+09:00) Seoul</option>
                <option value="Asia/Yakutsk">(GMT+09:00) Yakutsk</option>
                <option value="Australia/Adelaide">(GMT+09:30) Adelaide</option>
                <option value="Australia/Darwin">(GMT+09:30) Darwin</option>
                <option value="Australia/Brisbane">(GMT+10:00) Brisbane</option>
                <option value="Australia/Canberra">(GMT+10:00) Canberra, Melbourne, Sydney</option>
                <option value="Australia/Hobart">(GMT+10:00) Hobart</option>
                <option value="Pacific/Guam">(GMT+10:00) Guam, Port Moresby</option>
                <option value="Asia/Vladivostok">(GMT+10:00) Vladivostok</option>
                <option value="Asia/Magadan">(GMT+11:00) Magadan, Solomon Is., New Caledonia</option>
                <option value="Pacific/Auckland">(GMT+12:00) Auckland, Wellington</option>
                <option value="Pacific/Fiji">(GMT+12:00) Fiji, Kamchatka, Marshall Is.</option>
                <option value="Pacific/Tongatapu">(GMT+13:00) Nuku'alofa</option>
              </select>
              {/*<option value=""></option>
                {stateTimeZones.map(timeZone =>
                  <option key={timeZone} value={timeZone}>{timeZone}</option>
                )}
              </select>*/}
              {reactForm.errors.timezone ? (
                <p className="mt-2 text-base text-red-600 dark:text-red-500">
                  {reactForm.errors.timezone}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
function Settings() {
  return (
    <div>
      <Navigation children={Content} />
    </div>
  );
}
export default withRouter(Settings);
